var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "upload-file"
  }, [_vm.row ? _c('b-modal', {
    attrs: {
      "id": "repApproveModal",
      "centered": "",
      "size": "md",
      "no-close-on-backdrop": "",
      "hide-footer": ""
    },
    scopedSlots: _vm._u([{
      key: "modal-header",
      fn: function fn() {
        return [_c('div', {
          staticClass: "pb-1 repApproveModal-header text-center"
        }, [_c('h4', [_vm._v("Approval Request")]), _c('b-button', {
          staticClass: "btn-container",
          attrs: {
            "variant": "close-btn"
          },
          on: {
            "click": _vm.closeModal
          }
        }, [_c('i', {
          staticClass: "fas fa-times"
        })])], 1)];
      },
      proxy: true
    }], null, false, 4241941008)
  }, [_c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('div', {
    staticClass: "d-flex repApproveModal-form"
  }, [_c('div', {
    staticClass: "exclaim-bg"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/images/exclaim.svg")
    }
  })]), _c('div', {}, [_c('div', {
    staticClass: "note-txt"
  }, [_vm._v(" Do you want to proceed and approve this card request? ")]), _c('div', {
    staticClass: "d-flex align-items-center gap-2 mt-4"
  }, [_c('label', {
    attrs: {
      "for": "cards_request"
    }
  }, [_vm._v(" A"), _c('b', [_vm._v(" $5.00 fee will be charged ")]), _vm._v("to this member if the requested is approved. ")])]), _c('div', {
    staticClass: "note-txt"
  }, [_vm._v(" Would you like to charge the $5.00 fee? ")]), _c('div', {
    staticClass: "d-flex align-items-center gap-2 mt-4 justify-content-center"
  }, [_c('b-form-checkbox', {
    staticClass: "checkbox-default",
    attrs: {
      "value": "1",
      "unchecked-value": "0"
    },
    model: {
      value: _vm.cards_request,
      callback: function callback($$v) {
        _vm.cards_request = $$v;
      },
      expression: "cards_request"
    }
  }), _c('label', {
    attrs: {
      "for": "cards_request"
    }
  }, [_vm._v("Yes, charge the member")]), _c('b-form-checkbox', {
    staticClass: "checkbox-default",
    attrs: {
      "value": "0",
      "unchecked-value": "0"
    },
    model: {
      value: _vm.cards_request,
      callback: function callback($$v) {
        _vm.cards_request = $$v;
      },
      expression: "cards_request"
    }
  }), _c('label', {
    attrs: {
      "for": "cards_request"
    }
  }, [_vm._v("No, do not charge")])], 1)])]), _c('div', {
    staticClass: "d-flex align-items-center justify-content-end gap-2 mt-4"
  }, [_c('button', {
    staticClass: "cancel-btn request-cancel m-0",
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("Cancel")]), _c('button', {
    staticClass: "approve-btn univ-btn m-0",
    on: {
      "click": _vm.acceptRequest
    }
  }, [_vm._v("Yes Approve")])])])], 1) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }